import { create } from 'zustand';

type State = {
  open: boolean;
};

type Actions = {
  setOpen: (value: boolean) => void;
};

export const useModalState = create<State & Actions>((set) => ({
  open: false,
  setOpen: (value) => set({ open: value }),
}));
